// libs
import { styled } from '@nykaa/ui-components';

export const SizeGuideNudgeContainer = styled.div<{ needTopMargin: boolean }>`
  ${({ theme, needTopMargin }) => {
    const { spacing, borders } = theme;
    return `
      margin-top: ${needTopMargin ? spacing.spacing60 : "0px"};
      padding: ${spacing.spacing10} ${spacing.spacing20} ${spacing.spacing10} 0px; 
      border-radius: 0px ${borders.radius20} ${borders.radius20} 0px;
      width: fit-content;
      background: linear-gradient(90deg, rgba(255, 240, 239, 0.00) 19.5%, #FFF0EF 100%);
    `;
  }};
`;

export const SizeGuideNudgeText = styled.span`
    ${({ theme }) => theme.typography.bodySmall};
    ${({ theme }) => {
    const { colors } = theme;
    return `
      color: ${colors.negative};
      display: flex;
    `;
  }};
`;
